import { IStrapiMedia } from './strapi-media';

enum StatusColor {
  Red = 'red',
  Yellow = 'yellow',
  Green = 'green'
}

export interface IUseCaseVisualSubcard {
  tag: string;
  description: string;
  status_color: StatusColor;
}

export interface IUseCaseVisualOverlay {
  tag: string;
  description: string;
}

export interface IUseCaseVisual {
  video: IStrapiMedia;
  video_still: IStrapiMedia;
  overlay: IUseCaseVisualOverlay | null;
  subcard: IUseCaseVisualSubcard | null;
}
